<div v-if="showPinboard" class="tt-w-comments-pinboard-teaser">
  <div class="tt-w-comments-pinboard-teaser__container" :style="containerStyles">
    <figure v-if="showCommentsPromoBox" 
            class="tt-w-comments-pinboard-teaser__promo" 
            :class="promoClasses"
            :style="promoStyles">
      <div class="tt-w-comments-pinboard-teaser__promo-text">
        <p v-html="$msg('commentsPinboardTeaser.promoBoxText')"></p>
        <a :href="teaserConfig.promoButtonUrl" class="tt-w-comments-pinboard-teaser__promo-cta tt-u-ignore-default" rel="nofollow" v-html="$msg('commentsPinboardTeaser.promoBoxBtnText')"></a>
      </div>
      <span class="tt-w-comments-pinboard-teaser__promo-credit" v-html="$msg('commentsPinboardTeaser.poweredBy')"></span>
    </figure>
    <tt-pinboard-item v-for="item in visibleItems"
                      :item="item"
                      :key="item.id"
                      :style="itemStyles" 
                      :commentMaxLength="teaserConfig.commentMaxLength"
                      :commentsCount="item.commentsCount"
                      :hoverTitleMaxLength="teaserConfig.hoverTitleMaxLength"
                      :linesLimit="currentBreakpointConfig.commentLinesLimit"
                      :showReviewStars="teaserConfig.showReviewStars"
                      :titleMaxLength="teaserConfig.titleMaxLength"
                      :userNameMaxLength="teaserConfig.userNameMaxLength"></tt-pinboard-item>
    <div v-for="i in numberOfPlaceholders" class="tt-w-comments-pinboard-teaser__placeholder" :style="itemStyles"></div>
  </div>
</div>
